import { render, staticRenderFns } from "./FormRadioList.vue?vue&type=template&id=56c87028&"
import script from "./FormRadioList.vue?vue&type=script&lang=js&"
export * from "./FormRadioList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports